import { useMemo } from 'react';

import { FlagOptions } from '@atlassian/forge-ui/iframe';

import { useFlag } from './flag';

/*
 * A hook which generates bridge props which can be directly
 * passed into a Forge extension point from Frontbucket
 */
export const useForgeBridge = () => {
  const { dismissFlag, showFlag } = useFlag({ enableForPdvs: true });

  const mapForgeToBbFlag = ({
    id,
    title,
    description,
    type,
    appearance,
    isAutoDismiss,
    onClose,
    actions,
  }: FlagOptions) => ({
    id: `${id}`,
    title: title || '',
    description,
    iconType: appearance || type,
    autoDismiss: isAutoDismiss,
    onDismissed: onClose,
    nonIntlActions: actions?.map(({ text, onClick }) => ({
      content: text,
      onClick,
    })),
  });

  return useMemo(
    () => ({
      showFlag: (options: FlagOptions) => {
        showFlag(mapForgeToBbFlag(options));
        return true;
      },
      closeFlag: ({ id }: { id: string }) => {
        dismissFlag(id);
        return true;
      },
    }),
    [dismissFlag, showFlag]
  );
};
